document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu-toggle');
  const nav = document.querySelector('#PrimaryNav');

  menu?.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') === 'true';
    menu.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('open', !open);
  });

  document.querySelectorAll('[data-team-finder]').forEach((finder) => {
    const search = finder.querySelector('[data-team-search]');
    const select = finder.querySelector('[data-team-select]');
    const go = () => {
      if (select?.value) window.location.href = select.value;
    };

    search?.addEventListener('input', () => {
      const term = search.value.trim().toLowerCase();
      let firstMatch = null;

      [...select.options].forEach((option, index) => {
        if (index === 0) return;
        const matches = option.text.toLowerCase().includes(term);
        option.hidden = !matches;
        if (matches && !firstMatch) firstMatch = option;
      });

      if (term && firstMatch) select.value = firstMatch.value;
      if (!term) select.value = '';
    });

    search?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        go();
      }
    });

    select?.addEventListener('change', () => {
      if (select.value && finder.classList.contains('team-nav-picker')) go();
    });

    finder.querySelector('[data-team-go]')?.addEventListener('click', go);
  });
});
